// extracted by mini-css-extract-plugin
export default {"container":"FP-z"};